var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',{staticClass:"mt-4"},[_c('v-col',{attrs:{"cols":"12","csm":"6","md":"6"}},[_c('v-text-field',{attrs:{"label":"Code","dense":"","outlined":"","rules":_vm.requiredRule},model:{value:(_vm.value.code),callback:function ($$v) {_vm.$set(_vm.value, "code", $$v)},expression:"value.code"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }